import React from "react";
import Avatar from "@mui/material/Avatar";

// Function to generate a consistent color based on a string
function stringToColor(string) {
  let hash = 0;

  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

// Function to get avatar props based on the name
function stringAvatar(name, size) {
  if (!name) return { children: "?" };

  const nameParts = name.split(" ");
  const initials =
    nameParts.length > 1
      ? `${nameParts[0][0]}${nameParts[1][0]}`
      : `${nameParts[0][0]}`;

  // Font size scales with avatar size
  const fontSize = Math.max(size / 2, 10);

  return {
    sx: {
      bgcolor: stringToColor(name),
      color: "#fff",
      fontSize: `${fontSize}px`,
    },
    children: initials.toUpperCase(),
  };
}

// Reusable Avatar Component
const ColoredAvatar = ({ name, size = 40 }) => {
  return (
    <Avatar
      {...stringAvatar(name, size)}
      sx={{ width: size, height: size, ...stringAvatar(name, size).sx }}
    />
  );
};

export default ColoredAvatar;
